<template>
    <v-card>
        <v-card-title>
            {{$t('event.galleries')}}
            <v-spacer></v-spacer>
             <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initAddGallery">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table
                      :headers="headers"
                      :items="tableGalleries"
                      :loading="isGalleryPending"
                      @pagination="currentPagination"
                      disable-sort>
            <template v-slot:item.scroller="{value}">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.createdAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.updatedAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.photos="{value}">
                {{value.length}}
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn color="primary"
                       @click="initEditGallery(item)">
                    {{$t('edit')}}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" dark class="ml-3"
                       @click="deleteGallery(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <v-dialog v-model="showEditGalleryDialog"
                  fullscreen
                  persistent
                  hide-overlay>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="confirmCancelItemDialogShown=true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{$t('event.galleries')}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditGalleryFormValid">
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                  :label="$t('event_gallery.title')"
                                                  :placeholder="$t('event_gallery.title')"
                                                  v-model="editingGallery.title"
                                                  :rules="titleRules"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                  :label="$t('event_gallery.key')"
                                                  :placeholder="$t('event_gallery.key')"
                                                  v-model="editingGallery.key"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                  :label="$t('event_gallery.link')"
                                                  :placeholder="$t('event_gallery.link')"
                                                  v-model="editingGallery.link"></v-text-field>
                                </v-col>
                            </v-row>
                            
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                  :label="$t('event_gallery.tour')"
                                                  :placeholder="$t('event_gallery.tour')"
                                                  v-model="editingGallery.tour"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                  :label="$t('event_gallery.description')"
                                                  :placeholder="$t('event_gallery.description')"
                                                  v-model="editingGallery.description"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col style="padding-top:0px">
                                    <v-checkbox
                                        :label="$t('event_gallery.launch')"
                                        v-model="editingGallery.launch"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            
                            <v-row>
                                <v-file-input accept="image/*"
                                              :label="$t('event_gallery.banner') + ' ' + $t('event_gallery.recommendedBannerSize')"
                                              v-model="editingGallery.banner"
                                              :rules="bannerRules"
                                              @change="handleGalleryChanged(editingGallery)">
                                    <template v-slot:selection="{file}">
                                        <v-img v-if="isImageSrcValid(editingGallery)" :src="getImageSrc(editingGallery)"
                                               max-width="250px"
                                               max-height="250px">
                                        </v-img>
                                    </template>
                                </v-file-input>
                            </v-row>
                        </v-form>

                        <v-row>
                            <v-col class="mt-10 text-right">
                                <v-btn class="ma-5" color="primary" @click="showImportPhoto = true">
                                    {{$t('event_gallery.import_photos')}}
                                    <v-icon right>mdi-plus</v-icon>
                                </v-btn>

                                <v-btn class="ma-5" color="primary" @click="editPhotoDetails">
                                    {{$t('event_gallery.edit')}}
                                    <v-icon right>mdi-pencil</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>

                        <!-- <v-row>
                            <v-col class="text-right">
                                <v-btn color="primary" @click="addGalleryItem">
                                    {{$t('add')}}
                                    <v-icon right>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row> -->

                        <v-row>
                            <v-col v-if="galleryItems.length > 0">
                                <h2 class="pb-5">{{$t('event_gallery.reorder')}}</h2>

                                <draggable 
                                    v-model="galleryItems"
                                    :noTransitionOnDrag="false"
                                    :multi-drag="true"
                                    selected-class='selected'
                                    ghost-class="ghost"
                                    >
                                    <transition-group tag="div" class="grid" name="grid">
                                        <div class="gridPhotoCell" v-for="element in galleryItems" :key="element.__isTemp ? element.__id : element.id">
                                            <v-img v-if="isImageSrcValid(element)" :src="getImageSrc(element)">
                                            </v-img>
                                        </div>
                                    </transition-group>
                                </draggable>
                            </v-col>
                            
                            <v-col v-if="!(galleryItems.length > 0)">
                                <h2 color="red">{{$t('event_gallery.empty')}}</h2>
                            </v-col>
                        </v-row>

                        <v-dialog
                            v-model="showImportPhoto"
                            width="100%"
                            persistent>
                            <v-card>
                                <v-card-title class="headline pb-10">{{$t('event_gallery.import_photos')}}</v-card-title>
                                
                                <v-card-text>
                                    <v-spacer></v-spacer>
                                    <v-file-input accept="image/*"
                                                multiple
                                                small-chips
                                                counter
                                                show-size
                                                :label="$t('gallery_item.photos')"
                                                :placeholder="$t('gallery_item.select_photos')"
                                                v-model="listOfImportPhotos">
                                    </v-file-input>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="mb-5 mr-5"
                                        @click="handleCloseImportPhoto">
                                        {{ $t('cancel') }}
                                    </v-btn>

                                    <v-btn class="mb-5 mr-5" color="primary" @click="batchAddGalleryItem">
                                        {{$t('event_gallery.import')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <v-dialog
                            v-model="showEditGalleryItem"
                            width="100%"
                            persistent>
                            <v-card>
                                <v-card-title class="headline pb-10">
                                    {{$t('gallery_item.photo_detail')}}
                                    <v-spacer></v-spacer>
                                    <v-btn class="mr-3" :disabled="!selectedgalleryItems.length" :dark="!!selectedgalleryItems.length" color="primary" @click="reorderDialog = true">
                                        Reorder ({{selectedgalleryItems.length}})
                                    </v-btn>
                                    <v-btn class="mr-3" :disabled="!selectedgalleryItems.length" :dark="!!selectedgalleryItems.length" color="primary" @click="shDialog = true">
                                        Show / Hide ({{selectedgalleryItems.length}})
                                    </v-btn>
                                    <v-btn color="red" :disabled="!selectedgalleryItems.length" :dark="!!selectedgalleryItems.length" class="ma-2" @click="dDialog = true">
                                        {{$t('delete')}} ({{selectedgalleryItems.length}})
                                        <v-icon right>mdi-delete</v-icon>
                                    </v-btn>
                                </v-card-title>
                                
                                <v-card-text>
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="search"
                                                append-icon="mdi-magnify"
                                                :label="$t('search')"
                                                single-line
                                                hide-details
                                                clearable>
                                    </v-text-field>
                                    <v-data-table
                                                :headers="galleryItemHeaders"
                                                :items="editingGalleryItems"
                                                :search="search"
                                                disable-sort
                                                show-select
                                                v-model="selectedgalleryItems"
                                                >
                                        <template v-slot:item.createdAt="{value}">
                                            {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                                        </template>
                                        <template v-slot:item.updatedAt="{value}">
                                            {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                                        </template>
                                        <template v-slot:item.isShown="{item,value}">
                                            {{(value) ? 'Show' : 'Hide'}}
                                        </template>
                                        <template v-slot:item.photo="{item}">
                                            <v-file-input 
                                                        accept="image/*"
                                                        :label="$t('gallery_item.photo')"
                                                        v-model="item.photo"
                                                        :clearable="false"
                                                        @change="handleGalleryItemChanged(item)"
                                                        >
                                                <template v-slot:selection="{file}">
                                                    <v-img v-if="item && (item.src || item.photo) && isImageSrcValid(item)" :src="getImageSrc(item)"
                                                            max-width="200px"
                                                            max-height="200px"></v-img>
                                                </template>
                                            </v-file-input>
                                        </template>
                                        <template v-slot:item.description="{item}">
                                            <v-text-field :label="$t('gallery_item.description')"
                                                            v-model="item.description"></v-text-field>
                                        </template>
                                        <template v-slot:item.description_tc="{item}">
                                            <v-text-field :label="$t('gallery_item.description_tc')"
                                                            v-model="item.description_tc"></v-text-field>
                                        </template>
                                        <template v-slot:item.description_sc="{item}">
                                            <v-text-field :label="$t('gallery_item.description_sc')"
                                                            v-model="item.description_sc"></v-text-field>
                                        </template>
                                        <template v-slot:item.actions="{item}">
                                            <v-btn color="red" dark class="ml-3"
                                                    @click="deleteGalleryItem(item)">
                                                {{$t('delete')}}
                                                <v-icon right>mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="mb-5 mr-5" color="primary"
                                        @click="savePhotoDetails">
                                        {{ $t('save') }}
                                    </v-btn>
                                    <v-btn class="mb-5 mr-5"
                                        @click="confirmCancelPhotoDetailsDialogShown = true;">
                                        {{ $t('close') }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row justify="end">
                            <v-btn color="primary" @click="saveGallery" :disabled="!isEditGalleryFormValid">
                                {{$t('save')}}
                            </v-btn>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="shDialog" scrollable max-width="640px">
            <v-card>
                <v-btn color="primary" @click="toggleIsShown(true)" class="mx-5 mt-5">
                    Show selected photos
                </v-btn>
                <v-btn color="red" @click="toggleIsShown(false)" class="mx-5 my-5">
                    Hide selected photos
                </v-btn>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="shDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="reorderDialog" scrollable max-width="640px">
            <v-card>
                <v-text-field 
                          class="mx-5 mt-5"
                          outlined
                          v-model="reorderDialogValue"
                          label="Insert above another photo"
                          placeholder="Target photo order"
                          hide-details>
                </v-text-field>
                <v-btn color="primary" @click="reorder()" class="mx-5 my-5">
                    Insert
                </v-btn>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="reorderDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PopupAlert
            v-model="dDialog"
            title="Warning"
            message="Do you wish to delete all selected photos?"
            :onYes="batchDelete"
            :onNo="function(){dDialog=false}">
        </PopupAlert> 
        <PopupAlert
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="function(){confirmCancelItemDialogShown=false; showEditGalleryDialog=false;}"
            :onNo="function(){confirmCancelItemDialogShown=false}">
        </PopupAlert>
        <PopupAlert
            v-model="confirmCancelPhotoDetailsDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="function(){confirmCancelPhotoDetailsDialogShown=false; showEditGalleryItem = false;}"
            :onNo="function(){confirmCancelPhotoDetailsDialogShown=false}">
        </PopupAlert>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>

<style scoped>
    .grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        align-items: center;
        margin: 0 auto;
        max-width: 1150px;
        background: #efefef;
        border-radius: 25px;
        overflow: auto;
        max-height: 500px;
    }

    .gridPhotoCell {
        margin: 10px !important;
        max-width: 210px;
    }

    .gridPhotoCell:hover {
        cursor: pointer;
    }

    .grid-move {
        transition: all 0.3s;
    }

    .ghost {
        opacity: 0.25;
    }

    .selected {
        background-color: #f9c7c8;
        border: solid red 2px;
    }

    .button-spacer {
        width: 10px;
    }
</style>

<script>
    import {computed, ref, onMounted, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import _, {clone, cloneDeep} from "lodash";
    import draggable from 'vuedraggable';
    import Sortable from "sortablejs";
    import PopupAlert from "../../components/PopupAlert";
    import axios from 'axios';

    export default {
        name: 'EventGalleryList',
        components: {
            draggable,
            PopupAlert
        },
        setup(props, {root}) {
            const overlay = ref(false);
            const listOfImportPhotos = ref([]);

            const {EventGallery, GalleryItem} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);

            const galleryParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value,
                    },
                    $sort: {
                        createdAt: -1
                    }
                }
            });
            const {items: galleries, isPending: isGalleryPending} = useFind({
                model: EventGallery,
                params: galleryParams,
            });
            const titleRules = ref([
                value => !!value || 'Required',
            ]);
            const bannerRules = ref([
                value => !!value || 'Required',
            ]);
            // const sortedGalleries = ref([])

            
            const quickSortGalleries = function(sortgalleies){
                if(sortgalleies.length<2){
                    return sortgalleies
                }

                const chosenIndex = sortgalleies.length - 1
                const chosen  = sortgalleies[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortgalleies[i].galleryorder
                    temp < chosen.galleryorder ? a.push(sortgalleies[i]) : b.push(sortgalleies[i])
                }
                const output = [...quickSortGalleries(a),chosen,...quickSortGalleries(b)]
                return output
            }
            const sortedGalleries = computed(()=>{
                return quickSortGalleries(galleries.value)
            })
            const editOrderGalleries = ref([]);
            const headers = ref([
                {text: '',value:'scroller',width:80},
                {text: root.$t('event_gallery.order'),value:'galleryorder'},
                {text: root.$t('event_gallery.title'), value: 'title'},
                {text: root.$t('event_gallery.photo_count'), value: 'photos'},
                {text: '', value: 'actions'},
            ]);

            const tableGalleries = computed(()=>{
                return isEditOrderMode.value?editOrderGalleries.value:sortedGalleries.value
            })

            // Add / Edit Gallery
            const showEditGalleryDialog = ref(false);
            const isEditGalleryFormValid = ref(false);
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);

            const selectedgalleryItems = ref([]);
            const shDialog = ref(false);
            const reorderDialog = ref(false);
            const reorderDialogValue = ref('');
            const dDialog = ref(false);

            const editingGallery = ref(new EventGallery({eventId: eventId.value}));
            const galleryItems = ref([]);
            const galleryPhotos = ref([]);
            const editingGalleryItems = ref([]);

            const initAddGallery = function () {
                const galleryorder = galleries.value.length + 1
                editingGallery.value = new EventGallery({eventId: eventId.value, galleryorder: galleryorder});
                galleryItems.value = [];
                galleryPhotos.value = [];
                showEditGalleryDialog.value = true;
            };
            const initEditGallery = function (gallery) {
                if(isEditOrderMode.value)return ;
                editingGallery.value = cloneDeep(gallery);
                galleryItems.value = cloneDeep(gallery.photos);
                galleryPhotos.value = cloneDeep(gallery.photos);
                console.log(editingGallery);
                console.log(galleryItems);
                showEditGalleryDialog.value = true;
            };
            const updateEditGallery = function (gallery) {
                editingGallery.value = cloneDeep(gallery);
                editingGalleryItems.value = cloneDeep(gallery.photos)
                galleryItems.value = cloneDeep(gallery.photos);
                galleryPhotos.value = cloneDeep(gallery.photos);
            };
            const deleteGallery = function (gallery) {
                if(isEditOrderMode.value)return;
                if (confirm(root.$t('event_gallery.confirm_delete'))) {
                    gallery.remove();
                }
            };
            const handleGalleryChanged = (g) => {
                if (g.banner instanceof File)
                    g.src =  URL.createObjectURL(g.banner);
            }
            
            const handleGalleryItemChanged = (g) => {
                if (g.photo instanceof File)
                    g.src =  URL.createObjectURL(g.photo);
            }
            
            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderGalleries.value = cloneDeep(sortedGalleries.value)
            }
            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                for(let i=0;i<editOrderGalleries.value.length;i++){
                    await editOrderGalleries.value[i].save().then(()=>{
                        EventGallery.get(editOrderGalleries.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }


            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }


            // Gallery Photo
            const showEditGalleryItem = ref(false);
            const showImportPhoto = ref(false);
            const galleryItemHeaders = [
                {text: root.$t('gallery_item.order'), value: 'order'},
                {text: root.$t('gallery_item.photo'), value: 'photo'},
                {text: root.$t('gallery_item.description'), value: 'description'},
                {text: root.$t('gallery_item.description_tc'), value: 'description_tc'},
                {text: root.$t('gallery_item.description_sc'), value: 'description_sc'},
                {text: root.$t('gallery_item.isShown'), value: 'isShown'},
                {text: root.$t('gallery_item.event_guests.ev_email'), value: 'event_guests.ev_email'},
                {text: root.$t('gallery_item.event_guests.ev_firstname'), value: 'event_guests.ev_firstname'},
                {text: root.$t('gallery_item.event_guests.ev_lastname'), value: 'event_guests.ev_lastname'},
                {text: '', value: 'actions'},
            ];
            const getImageSrc = (obj)=>{
                if (obj)
                    return ((obj.banner) ? 
                            (obj.banner.src ? obj.banner.src : obj.src) : 
                            (obj.photo.src ? obj.photo.src : obj.src));
            }
            const isImageSrcValid = (obj) => {
                const objSrc = getImageSrc(obj);
                return (objSrc && objSrc.includes('http'))
            }
    
            // const addGalleryItem = function () {
            //     galleryItems.value.push(new GalleryItem({fGalleryId: editingGallery.value.id}))
            // };
            const batchAddGalleryItem = function() {
                listOfImportPhotos.value.map((p)=>{
                    const newItem = new GalleryItem({fGalleryId: editingGallery.value.id});
                    newItem.photo = p;
                    if (p instanceof File)
                        newItem.src =  URL.createObjectURL(p);
                    galleryItems.value.push(newItem);
                });
                listOfImportPhotos.value = [];
                showImportPhoto.value = false;
            }
            const deleteGalleryItem = async function (item) {
                if (confirm(root.$t('gallery_item.confirm_delete'))) {
                    overlay.value = true;
                    let successDel = false;

                    let i = -1;
                    editingGallery.value.photos.forEach((p, index) => {
                        if (p.__id === item.__id) {
                            i = index;
                        }
                    });

                    if (item.__isTemp) {
                        editingGallery.value.photos.splice(i, 1);
                        galleryItems.value.splice(i, 1);
                        successDel = true;
                    } else {
                        await item.remove().then((result)=>{
                            EventGallery.get(editingGallery.value.id).then((result)=>{
                                updateEditGallery(result)
                            });

                            successDel = true;
                        }).catch((e)=>{
                            root.$handleFeatherError(e);
                        });
                    }

                    if (successDel) {
                        root.$store.dispatch('showSnackBar', root.$t('gallery_item.del_successful'))
                    }
                    overlay.value = false;
                }
            };

            const batchDelete = async () => {
                overlay.value = true;
                let i = selectedgalleryItems.value.length;
                const promises = [];
                editingSelectedgalleryItems.value = cloneDeep(selectedgalleryItems.value);
                while (i--) {
                    promises.push(
                        editingSelectedgalleryItems.value[i].remove()
                    );
                }
                await Promise.all(promises).then(() => {
                    selectedgalleryItems.value = [];
                    EventGallery.get(editingGallery.value.id).then((result)=>{
                        updateEditGallery(result)
                    });
                    root.$store.dispatch('showSnackBar', root.$t('gallery_item.del_successful'));
                }, root.$handleFeatherError.bind(root));
                dDialog.value = false;
                overlay.value = false;
            }

            const editingSelectedgalleryItems = ref([]);
            const toggleIsShown = async (show) => {
                overlay.value = true;
                let i = selectedgalleryItems.value.length;
                const promises = [];
                editingSelectedgalleryItems.value = cloneDeep(selectedgalleryItems.value);
                while (i--) {
                    if (show) {
                        if (editingSelectedgalleryItems.value[i].isShown) { continue; }
                        editingSelectedgalleryItems.value[i].isShown = true;
                    } else {
                        if (!editingSelectedgalleryItems.value[i].isShown) { continue; }
                        editingSelectedgalleryItems.value[i].isShown = false;
                    }
                    promises.push(
                        editingSelectedgalleryItems.value[i].save()
                    );
                }
                await Promise.all(promises).then(() => {
                    selectedgalleryItems.value = [];
                    EventGallery.get(editingGallery.value.id).then((result)=>{
                        updateEditGallery(result)
                    });
                    root.$store.dispatch('showSnackBar', root.$t('gallery_item.save_successful'));
                }, root.$handleFeatherError.bind(root));
                shDialog.value = false;
                overlay.value = false;
            }

            const reorder = async () => {
                overlay.value = true;
                const targetIndex = galleryItems.value.map(item => item.order).indexOf(Number(reorderDialogValue.value));
                if (reorderDialogValue.value == '' // check empty
                    || Number(reorderDialogValue.value) < 0 // check input value < 0
                    || selectedgalleryItems.value.map(item => item.order).includes(Number(reorderDialogValue.value)) // check input value
                    || targetIndex == -1) {
                    overlay.value = false;
                    root.$store.dispatch('showSnackBar', 'Target order is not valid.');
                    return;
                }
                let response;
                try {
                    const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
                    response = await axios.create({
                        headers: {'Authorization': window.localStorage.getItem('feathers-jwt')}
                    }).post(`${prefixUrl}/reorder-api/reorder`, {
                        eventId: eventId.value,
                        galleryId: editingGallery.value.id,
                        items: selectedgalleryItems.value.map(item => item.id),
                        dest: galleryItems.value[targetIndex].id
                    });
                } catch (e) {
                    root.$handleFeatherError(e);
                    root.$store.dispatch('showSnackBar', 'Server Error.');
                    overlay.value = false;
                    return;
                }
                if (response.data.isSuccess) {
                    EventGallery.get(editingGallery.value.id).then((result)=>{
                        updateEditGallery(result)
                    });
                    root.$store.dispatch('showSnackBar', "Items reordered.");
                } else {
                    if (response.data.error) {
                        overlay.value = false;
                        root.$store.dispatch('showSnackBar', response.data.error);
                        return;
                    }
                }
                selectedgalleryItems.value = [];
                reorderDialog.value = false;
                overlay.value = false;
            }

            watch (reorderDialog, (newVal, oldVal) => {
                if (!newVal && oldVal) {
                    reorderDialogValue.value = '';
                }
            })

            const editPhotoDetails = async function() {
                editingGalleryItems.value = cloneDeep(galleryItems.value);
                showEditGalleryItem.value = true
            }

            const savePhotoDetails = async function() {
                overlay.value = true;

                editingGalleryItems.value.map((item, i)=>{
                    item.order = i;
                })

                const promises = [];
                let i = editingGalleryItems.value.length;
                while (i--) {
                    if (_.isEqual(editingGalleryItems.value[i], galleryItems.value[i])) {
                        continue;
                    }
                    if (editingGalleryItems.value[i].photo) {
                        console.log(editingGalleryItems.value[i].photo);
                        if (editingGalleryItems.value[i].photo instanceof File)
                            editingGalleryItems.value[i].photo = await root.$uploadFile(editingGalleryItems.value[i].photo);
                    }
                    promises.push(
                        editingGalleryItems.value[i].save()
                    );
                }
                await Promise.all(promises).then(() => {
                    EventGallery.get(editingGallery.value.id).then((result)=>{
                        updateEditGallery(result)
                    });
                    root.$store.dispatch('showSnackBar', root.$t('gallery_item.save_successful'));
                }, root.$handleFeatherError.bind(root));
                
                showEditGalleryItem.value = false;
                overlay.value = false;
            }

            const saveGallery = async function() {
                // if (confirm(root.$t('event_gallery.confirm_save'))) {
                    overlay.value = true;

                    galleryItems.value.map((item, i)=>{
                        item.order = i;
                    })

                    try {
                        if (editingGallery.value.banner instanceof File) {
                            editingGallery.value.banner = {src: await root.$uploadFile(editingGallery.value.banner)};
                        }
                        if (!editingGallery.value.banner) {
                            editingGallery.value.banner = null;
                        }

                        await editingGallery.value.save();
                        
                        // Upload Gallery Photos
                        let promises = [];
                        for (let i = 0; i < galleryItems.value.length; i++) {
                            if (_.isEqual(galleryPhotos.value[i], galleryItems.value[i])) {
                                continue;
                            }
                            promises.push(new Promise((resolve, reject) => {
                                galleryItems.value[i].fGalleryId = editingGallery.value.id;
                                if (galleryItems.value[i].photo instanceof File) {
                                    root.$uploadFile(galleryItems.value[i].photo).then(id => {
                                        galleryItems.value[i].photo = id;

                                        resolve(galleryItems.value[i]);
                                    }, reject);
                                } else {
                                    resolve(galleryItems.value[i]);
                                }
                            }));
                        }

                        const photos = await Promise.all(promises);

                        await Promise.all(photos.map(p => p.save()));

                        await EventGallery.get(editingGallery.value.id).then((result)=>{
                            updateEditGallery(result)
                        });
                        
                        showEditGalleryDialog.value = false;
                        root.$store.dispatch('showSnackBar', root.$t('gallery_item.save_successful'));
                        // showEditGalleryDialog.value = false;
                    } catch(e) {
                        root.$handleFeatherError(e);
                    } finally {
                        overlay.value = false;
                    }

                    // .then(() => {
                    //
                    //
                    //     // Handle Gallery Items
                    //     Promise.allSettled()
                    //
                    //
                    //
                    //
                    // }, root.$handleFeatherError.bind(root));
                // }
            };


            const confirmCancelItemDialogShown = ref(false);
            const confirmCancelPhotoDetailsDialogShown = ref(false);

            const handleCloseImportPhoto = ()=>{
                listOfImportPhotos.value = [];
                showImportPhoto.value = false;
            }
            const handleClosePhotoItemsEditor = () => {
                if (confirm(root.$t('event_gallery.confirm_closePhotoItemsEditor'))) {
                    galleryItems.value = [];
                    showEditGalleryDialog.value = false;
                }
            }

            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderGalleries.value.splice(oldIndex,1)[0];
                            editOrderGalleries.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderGalleries.value.length;i++){
                                editOrderGalleries.value[i].galleryorder = i+1
                            }
                            editOrderGalleries.value = quickSortGalleries(editOrderGalleries.value);
                        }
                    }
                )
            });

            const customFilter = (value, search, item) => {
                search = search.toString().toLowerCase();
                return value != null &&
                    search != null &&
                    typeof value === 'string' &&
                    (
                        value.toString().toLowerCase().indexOf(search) !== -1
                        || item.event_guests.ev_firstname.toString().toLowerCase().indexOf(search) !== -1
                        || item.event_guests.ev_lastname.toString().toLowerCase().indexOf(search) !== -1
                        || item.event_guests.ev_fullname.toString().toLowerCase().indexOf(search) !== -1
                    )
            }

            return {
                galleries,
                isGalleryPending,
                sortedGalleries,
                
                titleRules,
                bannerRules,
                isEditGalleryFormValid,
                isEditOrderMode,

                headers,
                tableGalleries,
                showEditGalleryDialog,

                initAddGallery,
                initEditGallery,
                deleteGallery,
                saveGallery,
                handleGalleryChanged,

                editingGallery,



                galleryItemHeaders,

                galleryItems,
                galleryPhotos,
                listOfImportPhotos,
                
                getImageSrc,
                isImageSrcValid,

                // addGalleryItem,
                deleteGalleryItem,
                batchAddGalleryItem,

                showImportPhoto,    
                showEditGalleryItem,

                handleCloseImportPhoto, 
                handleClosePhotoItemsEditor,

                initEditOrder,
                cancelEditOrder,
                saveEditOrder,

                DateTime,
                getFileUrl: root.$getFileURL,
                overlay,

                confirmCancelItemDialogShown,
                confirmCancelPhotoDetailsDialogShown,
                currentPagination,

                selectedgalleryItems,
                shDialog,
                reorderDialog,
                reorderDialogValue,
                reorder,
                dDialog,
                editingSelectedgalleryItems,
                toggleIsShown,
                batchDelete,
                search: ref(''),
                customFilter,

                editingGalleryItems,
                editPhotoDetails,
                savePhotoDetails,
                handleGalleryItemChanged,
            }
        }
    }
</script>
